// Centralized SEO metadata per route.
// Used by the <SEO /> component (client-side <head> tags) and mirrors
// src/server/routes.js so titles/descriptions stay consistent whether the
// app is served statically (Netlify) or via the optional Express SSR server.

export const SITE_NAME = "Golfusion";
export const MAIN_WEBSITE_TITLE = "Golfusion | ";
export const DEFAULT_OG_IMAGE = "/og-image.jpg";

const seoRoutes = [
  {
    path: "/",
    title: "Golfusion Tournament Event - Indonesia",
    description:
      "Golfusion 'Connect on the Fairway' Golf Tournament 2026 - a unique networking event combining golf with business networking. Sentul Highland Golf Club, 29 August.",
  },
  {
    path: "/about",
    title: "Event Information",
    description:
      "Golfusion: 'Connect on the Fairway' is a unique networking event that combines the thrill of golf with the opportunity to expand your professional circle.",
  },
  {
    path: "/contact-us",
    title: "Contact Us",
    description:
      "Get in touch with the Golfusion team. PT. Bakhtera Inovasi Gemilang, Ruko Mutiara Taman Palem Blok B7 No. 20, Jalan Kamal Raya Outer Ring Road.",
  },
  {
    path: "/prices",
    title: "Ticket Prices",
    description: "Please select the package: Scramble & Individual.",
  },
  {
    path: "/price-details",
    title: "Ticket Details",
    description: "View detailed information about this Golfusion ticket.",
  },
  {
    path: "/sponsors",
    title: "Our Sponsors",
    description:
      "People and companies that make this event possible: Main Sponsor & Other Sponsors.",
  },
  {
    path: "/faq",
    title: "Frequently Asked Questions",
    description: "Answers to common inquiries about the Golfusion Event.",
  },
  {
    path: "/payment/pending",
    title: "Payment Page",
    description: "Complete your Golfusion ticket payment.",
  },
  {
    path: "/payment/qr",
    title: "QR Payment Page",
    description: "Scan the QR code to complete your Golfusion payment.",
  },
  {
    path: "/privacy-policy",
    title: "Privacy Policy",
    description: "Data that will be processed by us.",
  },
  {
    path: "/404",
    title: "Page Not Found",
    description: "We cannot find your page.",
  },
];

export const DEFAULT_SEO = seoRoutes[0];

// Matches a pathname (e.g. "/price-details/123") to its SEO entry,
// falling back to prefix-matching for dynamic routes.
export const getSeoForPath = (pathname) => {
  const exact = seoRoutes.find((route) => route.path === pathname);
  if (exact) return exact;

  const prefixMatch = seoRoutes
    .filter((route) => route.path !== "/" && pathname.startsWith(route.path))
    .sort((a, b) => b.path.length - a.path.length)[0];

  return prefixMatch || seoRoutes.find((r) => r.path === "/404");
};

export default seoRoutes;
